import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSofa: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSofa"><Path d="M22.5 17.5V11.5H18.5V13.5H5.5V11.25H1.5V17.5H22.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M20.5 11.5V4.5H3.5V11" stroke="currentColor" strokeLinecap="square"/><Path d="M4.5 17.5V19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M19.5 17.5V19.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSofa;
